import { Interval, IntervalSide } from '@/types/variable'

import { defineIntervalEndingSymbol } from './getIntervalEnding'

export function intervalToString(interval: Interval) {
  return `${defineIntervalEndingSymbol(
    interval.lowerEnding,
    IntervalSide.lower,
  )} ${interval.lowerBound} - ${interval.upperBound} ${defineIntervalEndingSymbol(
    interval.upperEnding,
    IntervalSide.upper,
  )}`
}
